import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, IconButton as MuiIconButton, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

export const FilesContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  // justifyContent : "space-between",
  marginTop: "20px",
  display: "flex",
  gap: "15px",
  flexWrap: "wrap",
}));

export const FileContainer = styled(Paper)(({ theme }) => ({
  // width : "fit-content",
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "column",
  padding: "20px",
}));

export const IconButton = styled(MuiIconButton)({
  width: "fit-content",

  "& > svg": {
    width: "24px",
  },
});

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon, {
  shouldForwardProp: (prop) => prop !== "color",
})<{ color?: string }>(({ theme, color }) => ({
  color: color ?? theme.palette.primary.main,
}));
